import * as tslib_1 from "tslib";
import { action, observable, computed } from 'mobx';
import ProjectApi from '../services/ProjectApi';
var ProjectStore = /** @class */ (function () {
    function ProjectStore() {
        this.ready = false;
        this.projects = null;
        this.projectStatistics = null;
        this.selectedUserSummary = null;
    }
    ProjectStore.prototype.load = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _a;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = this;
                        return [4 /*yield*/, ProjectApi.getProjectConfiguration()];
                    case 1:
                        _a.configuration = _b.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    Object.defineProperty(ProjectStore.prototype, "hasProject", {
        get: function () {
            return this.projects && this.projects.length > 0;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ProjectStore.prototype, "hasStatistics", {
        get: function () {
            return !!this.projectStatistics;
        },
        enumerable: true,
        configurable: true
    });
    ProjectStore.prototype.clear = function () {
        this.projects = null;
        this.projectStatistics = null;
        this.selectedUserSummary = null;
    };
    ProjectStore.prototype.loadProjects = function (sprintIndex) {
        return tslib_1.__awaiter(this, void 0, Promise, function () {
            var _a;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = this;
                        return [4 /*yield*/, ProjectApi.getProjects(sprintIndex)];
                    case 1:
                        _a.projects = _b.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    ProjectStore.prototype.loadProjectStatistics = function (projectId, sprintIndex) {
        return tslib_1.__awaiter(this, void 0, Promise, function () {
            var _a;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = this;
                        return [4 /*yield*/, ProjectApi.getProjectStatistics(projectId, sprintIndex)];
                    case 1:
                        _a.projectStatistics = _b.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    tslib_1.__decorate([
        observable
    ], ProjectStore.prototype, "ready", void 0);
    tslib_1.__decorate([
        observable
    ], ProjectStore.prototype, "configuration", void 0);
    tslib_1.__decorate([
        observable
    ], ProjectStore.prototype, "projects", void 0);
    tslib_1.__decorate([
        observable
    ], ProjectStore.prototype, "projectStatistics", void 0);
    tslib_1.__decorate([
        observable
    ], ProjectStore.prototype, "selectedUserSummary", void 0);
    tslib_1.__decorate([
        action.bound
    ], ProjectStore.prototype, "load", null);
    tslib_1.__decorate([
        computed
    ], ProjectStore.prototype, "hasProject", null);
    tslib_1.__decorate([
        computed
    ], ProjectStore.prototype, "hasStatistics", null);
    tslib_1.__decorate([
        action.bound
    ], ProjectStore.prototype, "clear", null);
    tslib_1.__decorate([
        action.bound
    ], ProjectStore.prototype, "loadProjects", null);
    tslib_1.__decorate([
        action.bound
    ], ProjectStore.prototype, "loadProjectStatistics", null);
    return ProjectStore;
}());
export default ProjectStore;



//////////////////
// WEBPACK FOOTER
// ./src/store/ProjectStore.ts
// module id = 371
// module chunks = 0